import { memo } from "react"

import { useColumnKeys } from "./atoms"
import { Cell } from "./Cell"

type RowProps = {
  id: string
  index: number
}

function _Row(props: RowProps) {
  const { index, id } = props
  const columns = useColumnKeys()
  return (
    <tr role="row">
      {columns.map((columnId) => {
        return (
          <Cell
            key={`${index}_${columnId}`}
            rowIndex={index}
            rowId={id}
            columnId={columnId}
          />
        )
      })}
    </tr>
  )
}

export const Row = memo(_Row)
